const defaultAlignment = 'left';

export { defaultAlignment };

export default ['left', 'center', 'right', 'justify'];